// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"39d9a4f9","3":"6c32ec40","11":"501807c0","227":"ce573709","319":"fe61ec57","356":"81bb0a8d","395":"9a27ebe0","437":"4ebd4ab2","453":"f41c86bd","627":"1c765785","685":"1789caed","822":"b83b5148"}[chunkId] + ".chunk.js";
};